import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import en from "../data/data.json";
import cs from "../data/data_cs.json";

export const Testimonials = (props) => {
  const { language } = useContext(LanguageContext);
  const translations = language === "cs" ? cs : en;

  // use translations first, then props.data as fallback
  const items =
    translations?.Testimonials && translations.Testimonials.length
      ? translations.Testimonials
      : (props.data && props.data.length ? props.data : []);

  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>{translations.TestimonialsTitle || "Testimonials"}</h2>
        </div>
        <div className="row">
          {items.length
            ? items.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      <img src={d.img} alt="" />{" "}
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta"> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
